import { createAsyncThunk } from "@reduxjs/toolkit";
import { createGraphQLThunk, createMultipartGraphQLThunk } from ".";
import { GET_APPROVAL_REQUESTS, GET_PRODUCT_DETAIL, GET_VENDOR_PRODUCT_DETAILS, PRODUCT_LISTING, SAVE_PRODUCT, SAVE_STOCK, VARIANT_WITHOUT_INVENTORY } from "../../utils/queries";

export const GetProductListing = createAsyncThunk(
  "productListingSlice/GetProductListing",
  createGraphQLThunk({
    query: PRODUCT_LISTING,
     getVariables: ({ filters }) => ({
      filters,
    }),
    responseKey: "getProductsListing",
  })
);

export const GetProductDetails = createAsyncThunk(
  "productDetailsSlice/GetProductDetails",
  createGraphQLThunk({
    query: GET_PRODUCT_DETAIL,
    getVariables: ({ productId, productBase }) => ({
      productId, productBase
    }),
    responseKey: "getProductDetailedInfo",
  })
);

export const GetVariantWithoutInventory = createAsyncThunk(
  "variantWithoutInventorySlice/GetVariantWithoutInventory",
  createGraphQLThunk({
    query: VARIANT_WITHOUT_INVENTORY,
    getVariables: ({ productId, inventoryId }) => ({
      productId, inventoryId
    }),
    responseKey: "getProductVariantsNotAddedToInventory",
    notError: true
  })
);

export const SaveStock = createAsyncThunk(
  "saveStockSlice/SaveStock",
  createGraphQLThunk({
    query: SAVE_STOCK,
    getVariables: ({ payload }) => ({
      payload
    }),
    responseKey: "saveStock",
    onSuccessMessage: "Added to Inventory Successfully!"
  })
);

export const SaveProduct = createAsyncThunk(
  "saveProductSlice/SaveProduct",
  createMultipartGraphQLThunk({
    query: SAVE_PRODUCT,
    getVariables: ({ payload }) => ({
      payload
    }),
    fileKeys: [
      "payload.images[]",  
      "payload.brandLogo",            
    ],
    responseKey: "saveVendorProduct",
    onSuccessMessage: "Product Saved Successfully!"
  })
);

export const GetApprovalRequests = createAsyncThunk(
  "approvalRequestsSlice/GetApprovalRequests",
  createGraphQLThunk({
    query: GET_APPROVAL_REQUESTS,
    getVariables: ({ payload }) => ({
      payload
    }),
    responseKey: "getApprovalRequest",
  })
);

export const GetVendorProductDetails = createAsyncThunk(
  "vendorProductDetailsSlice/GetVendorProductDetails",
  createGraphQLThunk({
    query: GET_VENDOR_PRODUCT_DETAILS,
    getVariables: ({ productId }) => ({
      productId
    }),
    responseKey: "getVendorProductDetail",
  })
);
